import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateChannelDocument } from './update.generated';

export const useUpdateChannel = (options: ApiOptions<typeof UpdateChannelDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(UpdateChannelDocument, {
    ...useNotifications(UpdateChannelDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.channels.update_success'),
    }),

    ...options,
  });
};
